import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IUpdateFn, IGetPutRequest, ITrainingType, ITrainingGroupRequirementsAddUpsert } from '../../interfaces'

const getSelectTrainingGroupRequirementsMutationRequest: IGetPutRequest = () => {
  return {
    method: 'put',
    url: `${config.baseUrl}/TrainingGroups/`,
  }
}

const useSelectTrainingGroupRequirementsMutation: IUseUpdateMutation<ITrainingType, ITrainingGroupRequirementsAddUpsert> = (params, options = {}) => {
  const request = useMemo(() => getSelectTrainingGroupRequirementsMutationRequest(params), [params])

  const selectTraining: IUpdateFn<ITrainingGroupRequirementsAddUpsert, ITrainingType> = useCallback(
    async data => {
      return axios({
        ...request,
        url: request.url + data.trainingGroupId + '/template/sync',
        data: data.trainingTypeIds
      }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ITrainingType, Error, any>({
    mutationFn: selectTraining,
    ...options,
  })

  return response
}

export default useSelectTrainingGroupRequirementsMutation